import React from 'react'

function Blog() {
  return (
    <>
    <div className="blog-section">
      <div className="container w-container">
        <div className="blog-title-block">
          <div className="section-title-block center-block">
            <div className="section-intro-block">Our blog &amp; News</div>
            <h2 className="section-title">
              Blog &amp; News on Photography
            </h2>
          </div>
        </div>
        <div className="blog-collection-list w-dyn-list">
          <div role="list" className="blog-list w-dyn-items">
            <div role="listitem" className="blog-item w-dyn-item">
              <div className="blog-wrapper">
                <div className="blog-thumbnail">
                  <img alt="Blog  Thumb Image" loading="lazy"
                    src="images/blog-1.jpg"
                    className="blog-thumb-image" />
                </div>
                <div className="blog-content-wrapper">
                  <div className="blog-date-block">
                    <img
                      src="https://assets.website-files.com/63f05cba0a6a4d0a5deb5950/63f5e9e72ad9a69dbc78309b_calnder-icon.svg"
                      loading="lazy" alt="Calnder Icom" className="calender-icon" />
                    <div>March 8, 2023</div>
                  </div>
                  <a href=""
                    className="blog-title-link-block w-inline-block">
                    <h3 className="blog-title">
                      13 social media apps you should be paying
                    </h3>
                  </a><a data-w-id="f6281052-dab0-f6c6-67e5-8a04cf8c962e"
                    href=""
                    className="blog-details-link-block w-inline-block">
                    <div className="blog-link-text">Read More</div>
                    <div
                        style={{
                            WebkitTransform:
                            'translate3d(0px, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)',
                            MozTransform:
                            'translate3d(0px, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)',
                            MsTransform:
                            'translate3d(0px, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)',
                            transform:
                            'translate3d(0px, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)',
                        }}
                        className="button-arrow-icon w-embed"
                        >
                      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="15" viewBox="0 0 21 15" fill="none">
                        <path id="Vector"
                          d="M20.7983 7.97827L13.8631 14.7628C13.614 15.0474 13.1762 15.0806 12.8853 14.8368C12.5943 14.5931 12.5604 14.1648 12.8096 13.8802C12.8329 13.8537 12.8581 13.8289 12.8853 13.8062L18.6345 8.17505H0.693503C0.310515 8.17505 0 7.87128 0 7.49656C0 7.12184 0.310515 6.81813 0.693503 6.81813H18.6345L12.8853 1.19377C12.5943 0.950055 12.5604 0.521748 12.8096 0.237163C13.0588 -0.0474224 13.4966 -0.0805969 13.7875 0.163175C13.8146 0.185913 13.8399 0.210634 13.8631 0.237163L20.7984 7.02173C21.0672 7.28626 21.0672 7.71363 20.7983 7.97827Z"
                          fill="currentColor" />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div role="listitem" className="blog-item w-dyn-item">
              <div className="blog-wrapper">
                <div className="blog-thumbnail">
                  <img alt="Blog  Thumb Image" loading="lazy"
                    src="images/blog-2.jpg"
                    className="blog-thumb-image" />
                </div>
                <div className="blog-content-wrapper">
                  <div className="blog-date-block">
                    <img
                      src="https://assets.website-files.com/63f05cba0a6a4d0a5deb5950/63f5e9e72ad9a69dbc78309b_calnder-icon.svg"
                      loading="lazy" alt="Calnder Icom" className="calender-icon" />
                    <div>March 8, 2023</div>
                  </div>
                  <a href=""
                    className="blog-title-link-block w-inline-block">
                    <h3 className="blog-title">
                      12 social apps you should be paying attention to
                    </h3>
                  </a><a data-w-id="f6281052-dab0-f6c6-67e5-8a04cf8c962e"
                    href=""
                    className="blog-details-link-block w-inline-block">
                    <div className="blog-link-text">Read More</div>
                    <div
                        style={{
                            WebkitTransform:
                            'translate3d(0px, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)',
                            MozTransform:
                            'translate3d(0px, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)',
                            MsTransform:
                            'translate3d(0px, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)',
                            transform:
                            'translate3d(0px, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)',
                        }}
                        className="button-arrow-icon w-embed"
                        >
                      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="15" viewBox="0 0 21 15" fill="none">
                        <path id="Vector"
                          d="M20.7983 7.97827L13.8631 14.7628C13.614 15.0474 13.1762 15.0806 12.8853 14.8368C12.5943 14.5931 12.5604 14.1648 12.8096 13.8802C12.8329 13.8537 12.8581 13.8289 12.8853 13.8062L18.6345 8.17505H0.693503C0.310515 8.17505 0 7.87128 0 7.49656C0 7.12184 0.310515 6.81813 0.693503 6.81813H18.6345L12.8853 1.19377C12.5943 0.950055 12.5604 0.521748 12.8096 0.237163C13.0588 -0.0474224 13.4966 -0.0805969 13.7875 0.163175C13.8146 0.185913 13.8399 0.210634 13.8631 0.237163L20.7984 7.02173C21.0672 7.28626 21.0672 7.71363 20.7983 7.97827Z"
                          fill="currentColor" />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div role="listitem" className="blog-item w-dyn-item">
              <div className="blog-wrapper">
                <div className="blog-thumbnail">
                  <img alt="Blog  Thumb Image" loading="lazy"
                    src="images/blog-3.jpg"
                    className="blog-thumb-image" />
                </div>
                <div className="blog-content-wrapper">
                  <div className="blog-date-block">
                    <img
                      src="https://assets.website-files.com/63f05cba0a6a4d0a5deb5950/63f5e9e72ad9a69dbc78309b_calnder-icon.svg"
                      loading="lazy" alt="Calnder Icom" className="calender-icon" />
                    <div>September 22, 2023</div>
                  </div>
                  <a href=""
                    className="blog-title-link-block w-inline-block">
                    <h3 className="blog-title">
                    Canon DSLR cameras: Precision, Performance, and Stunning Visuals.
                    </h3>
                  </a><a data-w-id="f6281052-dab0-f6c6-67e5-8a04cf8c962e"
                    href=""
                    className="blog-details-link-block w-inline-block">
                    <div className="blog-link-text">Read More</div>
                    <div
                        style={{
                            WebkitTransform:
                            'translate3d(0px, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)',
                            MozTransform:
                            'translate3d(0px, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)',
                            MsTransform:
                            'translate3d(0px, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)',
                            transform:
                            'translate3d(0px, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)',
                        }}
                        className="button-arrow-icon w-embed"
                        >
                      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="15" viewBox="0 0 21 15" fill="none">
                        <path id="Vector"
                          d="M20.7983 7.97827L13.8631 14.7628C13.614 15.0474 13.1762 15.0806 12.8853 14.8368C12.5943 14.5931 12.5604 14.1648 12.8096 13.8802C12.8329 13.8537 12.8581 13.8289 12.8853 13.8062L18.6345 8.17505H0.693503C0.310515 8.17505 0 7.87128 0 7.49656C0 7.12184 0.310515 6.81813 0.693503 6.81813H18.6345L12.8853 1.19377C12.5943 0.950055 12.5604 0.521748 12.8096 0.237163C13.0588 -0.0474224 13.4966 -0.0805969 13.7875 0.163175C13.8146 0.185913 13.8399 0.210634 13.8631 0.237163L20.7984 7.02173C21.0672 7.28626 21.0672 7.71363 20.7983 7.97827Z"
                          fill="currentColor" />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default Blog